import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Hotel, MessageSquare } from 'lucide-react';
import { Button } from '@/components/ui/button';

const TurkishNavbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="bg-black shadow-sm py-4">
      <div className="container mx-auto px-4 flex justify-between items-center">
        <Link to="/tr" className="flex items-center space-x-2">
          <MessageSquare className="h-6 w-6 text-[#03A05C]" />
          <span className="text-xl font-bold text-white">Lobier AI</span>
        </Link>
        
        {/* Desktop Menu */}
        <div className="md:flex items-center space-x-6">
          <Link to="/features" className="text-gray-600 hover:text-hotel-primary transition-colors hidden">
            Özellikler
          </Link>
          <Link to="/pricing" className="text-gray-600 hover:text-hotel-primary transition-colors hidden">
            Fiyatlandırma
          </Link>
          <div className="flex items-center space-x-3">
            <Link to="/login" className='hidden'>
              <Button variant="outline" className="border-hotel-primary text-hotel-primary hover:bg-hotel-primary hover:text-white">
                Giriş
              </Button>
            </Link>
            <span className="text-gray-300 text-sm hidden md:block">Ücretsiz Demo İste</span>
            <Link to="/iletisim">
              <Button className="bg-white hover:bg-white/90 text-xs md:text-sm text-black">
              Otelinizde Deneyin
              </Button>
            </Link>
          </div>
        </div>
        
        {/* Mobile menu button */}
        <button 
          className="hidden text-gray-500"
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      
      {/* Mobile Menu */}
      {isOpen && (
        <div className="hidden absolute top-16 left-0 right-0 bg-white z-50 shadow-md animate-fade-in">
          <div className="container mx-auto px-4 py-4 flex flex-col space-y-4">
            <Link 
              to="/features" 
              className="text-gray-600 hover:text-hotel-primary transition-colors py-2 hidden"
              onClick={() => setIsOpen(false)}
            >
              Özellikler
            </Link>
            <Link 
              to="/pricing" 
              className="text-gray-600 hover:text-hotel-primary transition-colors py-2 hidden"
              onClick={() => setIsOpen(false)}
            >
              Fiyatlandırma
            </Link>
            <div className="flex flex-col space-y-3 pt-2">
              <Link to="/login" onClick={() => setIsOpen(false)} className='hidden'>
                <Button variant="outline" className="w-full border-hotel-primary text-hotel-primary hover:bg-hotel-primary hover:text-white">
                  Giriş
                </Button>
              </Link>
              <Link to="/iletisim" onClick={() => setIsOpen(false)}>
                <Button className="w-full bg-hotel-primary hover:bg-hotel-primary/90 text-white">
                  Başlayın
                </Button>
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default TurkishNavbar; 